module.exports = __webpack_public_path__ + "static/media/haa.e3035ca9.ogg";